import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { OtpVerificationProperties, useOtpVerification } from "./useOtpVerification";

import { DraftOtpVerification } from "./DraftOtpVerification";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { OtpVerification } from "./OtpVerification";
import { Registry } from "../../../../base/register";

export const OtpVerificationComponent: FC<IControlAttributes> = ({
    children, props
}) => {
    const { status, properties, error } = useOtpVerification(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) {
        return <></>
    }

    return <OtpVerification {...properties}>
        {children}
    </OtpVerification>
}

Registry.addControl({
    id: "eb52207e-86fb-4fdc-9e7e-e9b65395906c",
    name: "OTP Verification",
    type: ControlType.OtpVerification,
    properties: OtpVerificationProperties,
    component: OtpVerificationComponent,
    draftComponent: DraftOtpVerification
})
